// import { useEffect, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import AddBooks from "./addBooks";
// import css from "./adm.module.css";
// import AddRuk from "../addRuk/addRuk";
// import ProductList from "./productList";
// import ManList from "./manList";
// import OrderList from "./orderList";
// import AddBlog from "../admBlog/addBlog";
// import AddPromo from "./addPromo";
// import Carton from "./carton";
// import CartonCha from "./cartonCha";
// import SurveyForm from "./surveyForm";
// import AddBooksTest from "./addBooksTest";
// import UserList from "./userList";
// import SeoBlock from "./seoBlock";
// import AutorAdm from "../autorAdm/autorAdm";
// import HeroAdm from "../heroAdm/heroAdm";
// import AddVideoOglyd from "./addVideoOglyd";
// import ProductListEditor from "./photoEditor";
// import { onAuthStateChanged } from "firebase/auth";

// import { auth } from "../../firebase";
// import AddBook from "./addBook";
// import UseFiles from "./useFiles";
// import HeroListEditor from "./HeroListEditor";
// import AutorListEditor from "./AutorListEditor";
// import VotingResults from "./votingResults";
// import PageListFor from "./pageListFor";
// import CopyFiltersToManuscript from "../addColectionFilter/copyFiltersToManuscript";
// import ManageResponses from "./manageResponses";
// import AdminManagement from "./adminManagement";
// import ExportProducts from "./downloadButton";
// import VideoReviews from "./VideoReviews";
// import SurveyList from "./SurveyList";

// import ManuscriptListEditor from "./ManuscriptList";
// import BlogListEditor from "./BlogListEditor";
// import CartonChaResults from "./CartonChaResults";
// import PromoList from "./promoList";
// import ActionList from "./ActionList";
// import CartDiscountManager from "./CartDiscountManager";
// import AddProductBundle from "./AddProductBundle";
// import AllPop from "./allPop";
// import SaleList from "./SaleList";
// import BusinessChatsPage from "./BusinessChatsPage";
// import DownloadRozetkaXmlButton from "./xml";
// export default function FullAdm({ admCha }) {
//   const [addB, setAddB] = useState(false);
//   const [addM, setAddM] = useState(false);
//   const [addBlog, setAddBlog] = useState(false);
//   const [bookList, setBookList] = useState(false);
//   const [manList, setManList] = useState(false);
//   const [prodList, setProdList] = useState(false);
//   const [promo, setPromo] = useState(false);
//   const [carton, setCarton] = useState(false);
//   const [cartonCha, setCartonCha] = useState(false);
//   const [question, setQuestion] = useState(false);
//   const [user, setUser] = useState(false);
//   const [seo, setSeo] = useState(false);
//   const [auth, setAuth] = useState(false);
//   const [hero, setHero] = useState(false);
//   const [addVideoW, setAddVideoW] = useState(false);
//   const [photoChange, setPhotoChange] = useState(false);
//   const [heroListE, setHeroListE] = useState(false);
//   const [autorListRed, setAutorListRed] = useState(false);
//   const [voutingResult, setVoutingResult] = useState(false);
//   const [pageInSite, setPageInSite] = useState(false);
//   const [manuscriptResp, setManuscriptResp] = useState(false);
//   const [adminManager, setAdminManager] = useState(false);
//   const [videoList, setVideoList] = useState(false);
//   const [oputuvaniaList, setOputuvaniaList] = useState(false);
//   const [editRukopus, setEditRukopus] = useState(false);
//   const [redBlog, setRedBlog] = useState(false);
//   const [chowObklad, setChowObklad] = useState(false);
//   const [discount, setDiscount] = useState(false);
//   const [discForSum, setDiscForSum] = useState(false);
//   const [addBundleProd, setAddBundleProd] = useState(false);
//   const [fullPopUpChang, setFullPopUpChang] = useState(false);
//   const [rozprodag, setRozprodag] = useState(false);
//   const [bussinesChat, setBussinesChat] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const isOrdersRoute = location.pathname.startsWith("/adm/order");
//   const resetAllSections = () => {
//     setAddB(false);
//     setAddM(false);
//     setAddBlog(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const openSectionByName = (sectionName) => {
//     resetAllSections();

//     switch (sectionName) {
//       case "addBooks":
//         setAddB(true);
//         break;
//       case "addMan":
//         setAddM(true);
//         break;
//       case "bookList":
//         setBookList(true);
//         break;
//       case "manList":
//         setManList(true);
//         break;
//       case "addBlog":
//         setAddBlog(true);
//         break;
//       case "promo":
//         setPromo(true);
//         break;
//       case "carton":
//         setCarton(true);
//         break;
//       case "cartonCha":
//         setCartonCha(true);
//         break;
//       case "question":
//         setQuestion(true);
//         break;
//       case "user":
//         setUser(true);
//         break;
//       case "seo":
//         setSeo(true);
//         break;
//       case "author":
//         setAuth(true);
//         break;
//       case "hero":
//         setHero(true);
//         break;
//       case "videoAdd":
//         setAddVideoW(true);
//         break;
//       case "photoChange":
//         setPhotoChange(true);
//         break;
//       case "heroList":
//         setHeroListE(true);
//         break;
//       case "authorList":
//         setAutorListRed(true);
//         break;
//       case "votingResults":
//         setVoutingResult(true);
//         break;
//       case "pages":
//         setPageInSite(true);
//         break;
//       case "manuscriptResp":
//         setManuscriptResp(true);
//         break;
//       case "admins":
//         setAdminManager(true);
//         break;
//       case "videoList":
//         setVideoList(true);
//         break;
//       case "surveyList":
//         setOputuvaniaList(true);
//         break;
//       case "editRukopus":
//         setEditRukopus(true);
//         break;
//       case "blogList":
//         setRedBlog(true);
//         break;
//       case "coverVoting":
//         setChowObklad(true);
//         break;
//       case "discount":
//         setDiscount(true);
//         break;
//       case "discForSum":
//         setDiscForSum(true);
//         break;
//       case "bundle":
//         setAddBundleProd(true);
//         break;
//       case "popup":
//         setFullPopUpChang(true);
//         break;
//       case "sale":
//         setRozprodag(true);
//         break;
//       case "businessChat":
//         setBussinesChat(true);
//         break;
//       default:
//         break;
//     }
//   };
//   useEffect(() => {
//     const sectionToOpen = location.state?.openSection;
//     if (!sectionToOpen) return;

//     openSectionByName(sectionToOpen);

//     navigate(location.pathname, {
//       replace: true,
//       state: null,
//     });
//   }, [location.state, location.pathname, navigate]);
//   const openOrdersPage = () => {
//     resetAllSections();
//     navigate("/adm/order/1");
//   };
//   const addBooksTrue = () => {
//     setAddB(!addB);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const addManTrue = () => {
//     setAddB(false);
//     setAddM(!addM);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const bookListCha = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(!bookList);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const manListCha = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(!manList);
//     setProdList(false);
//     setAddBlog(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setPhotoChange(false);
//     setAddVideoW(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const prodListFunc = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(!prodList);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const addBlogP = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(!addBlog);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const changeToPromo = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(!promo);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const cartonFun = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(!carton);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const cartonFunCha = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(!cartonCha);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const addQuestion = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(!question);
//     setUser(false);
//     setSeo(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const userBlock = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(!user);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const seoBlock = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(!seo);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const authBlock = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(!auth);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const heroBlock = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(!hero);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const addvideoO = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(!addVideoW);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const changeData = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(!photoChange);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const heroListI = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(!heroListE);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const sitePages = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(!pageInSite);
//     setManuscriptResp(false);
//     setVideoList(false);
//     setAdminManager(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const autorListR = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(!autorListRed);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const vouting = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(!voutingResult);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const manResponse = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(!manuscriptResp);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const adminComp = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(!adminManager);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const videoListFunc = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(!videoList);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const oputList = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(!oputuvaniaList);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const edRuk = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(!editRukopus);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const redaguvatuBlog = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(!redBlog);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const zminaObclad = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(!chowObklad);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const discountFunctions = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(!discount);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const discountForAllSum = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(!discForSum);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const funcForBundlleProd = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(!addBundleProd);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const funcForPopUp = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(!fullPopUpChang);
//     setRozprodag(false);
//     setBussinesChat(false);
//   };
//   const funcForRozprodag = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(!rozprodag);
//     setBussinesChat(false);
//   };
//   const funcBussinesChat = () => {
//     setAddB(false);
//     setAddM(false);
//     setBookList(false);
//     setManList(false);
//     setProdList(false);
//     setAddBlog(false);
//     setPromo(false);
//     setCarton(false);
//     setCartonCha(false);
//     setQuestion(false);
//     setUser(false);
//     setSeo(false);
//     setAuth(false);
//     setHero(false);
//     setAddVideoW(false);
//     setPhotoChange(false);
//     setHeroListE(false);
//     setAutorListRed(false);
//     setVoutingResult(false);
//     setPageInSite(false);
//     setManuscriptResp(false);
//     setAdminManager(false);
//     setVideoList(false);
//     setOputuvaniaList(false);
//     setEditRukopus(false);
//     setRedBlog(false);
//     setChowObklad(false);
//     setDiscount(false);
//     setDiscForSum(false);
//     setAddBundleProd(false);
//     setFullPopUpChang(false);
//     setRozprodag(false);
//     setBussinesChat(!bussinesChat);
//   };
//   return (
//     <div className={css.fullAdmWrapp}>
//       <div className={css.admList}>
//         <ul className={css.listUlForAdm}>
//           {admCha && (
//             <li className={css.listUlForAdmLi} onClick={adminComp}>
//               <Link
//                 className={`${css.listUlForAdmLiA} ${
//                   adminManager ? css.listUlForAdmLiAA : ""
//                 }`}
//               >
//                 Адміни
//               </Link>
//             </li>
//           )}
//           <li className={css.listUlForAdmLi} onClick={sitePages}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 pageInSite ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Сторінки сайту
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={addBooksTrue}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 addB ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Додати книгу
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={funcForBundlleProd}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 addBundleProd ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Каталог Cross-sell
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={addManTrue}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 addM ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Додати рукопис
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={edRuk}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 editRukopus ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Список Рукописів
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={bookListCha}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 bookList ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Список товарів
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={manListCha}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 manList ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Список рукописів
//             </Link>
//           </li>{" "}
//           <li className={css.listUlForAdmLi} onClick={manResponse}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 manuscriptResp ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Відгуки в рукописах
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={openOrdersPage}>
//             <button
//               type="button"
//               className={`${css.listUlForAdmLiA} ${
//                 isOrdersRoute ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Список замовлень
//             </button>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={addBlogP}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 addBlog ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Додати статтю
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={redaguvatuBlog}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 redBlog ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Список статей
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={addvideoO}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 addVideoW ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Додати відеоогляд
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={videoListFunc}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 videoList ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Відеоогляди
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={changeToPromo}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 promo ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Промокод
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={discountFunctions}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 discount ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Акції
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={funcForRozprodag}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 rozprodag ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Розпродаж
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={discountForAllSum}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 discForSum ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Знижка від суми
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={cartonFunCha}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 cartonCha ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Редагувати обкладинку
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={zminaObclad}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 chowObklad ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Голосування за обкладинку
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={vouting}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 voutingResult ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Результати голосування
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={addQuestion}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 question ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Додати опитування
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={oputList}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 oputuvaniaList ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Список опитувань
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={userBlock}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 user ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Список користувачів
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={seoBlock}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 seo ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Seo
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={authBlock}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 auth ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Додати автора
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={autorListR}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 autorListRed ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Список авторів
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={heroBlock}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 hero ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Додати героя
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={heroListI}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 heroListE ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Список Героїв
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={changeData}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 photoChange ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Змінити файли книги
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={funcForPopUp}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 fullPopUpChang ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Pop-Up
//             </Link>
//           </li>
//           <li className={css.listUlForAdmLi} onClick={funcBussinesChat}>
//             <Link
//               className={`${css.listUlForAdmLiA} ${
//                 bussinesChat ? css.listUlForAdmLiAA : ""
//               }`}
//             >
//               Бізнес чати
//             </Link>
//           </li>
//           <ExportProducts />
//           <DownloadRozetkaXmlButton />
//         </ul>
//       </div>
//       {discount && <ActionList />}
//       {adminManager && <AdminManagement />}
//       {addB && <AddBooksTest />}
//       {addM && <AddRuk />}
//       {bookList && <ProductList />}
//       {manList && <ManList />}
//       {/* {prodList && <OrderList />} */}
//       {isOrdersRoute && <OrderList />}
//       {addBlog && <AddBlog />}
//       {promo && <PromoList />}
//       {carton && <Carton />}
//       {cartonCha && <CartonCha />}
//       {question && <SurveyForm />}
//       {user && <UserList />}
//       {seo && <SeoBlock />}
//       {auth && <AutorAdm />}
//       {hero && <HeroAdm />}
//       {addVideoW && <AddVideoOglyd />}
//       {photoChange && <UseFiles />}
//       {heroListE && <HeroListEditor />}
//       {autorListRed && <AutorListEditor />}
//       {voutingResult && <VotingResults />}
//       {pageInSite && <PageListFor />}
//       {manuscriptResp && <ManageResponses />}
//       {videoList && <VideoReviews />}
//       {oputuvaniaList && <SurveyList />}
//       {editRukopus && <ManuscriptListEditor />}
//       {redBlog && <BlogListEditor />}
//       {chowObklad && <CartonChaResults />}
//       {discForSum && <CartDiscountManager />}
//       {addBundleProd && <AddProductBundle />}
//       {fullPopUpChang && <AllPop />}
//       {rozprodag && <SaleList />}
//       {bussinesChat && <BusinessChatsPage />}
//       {/* <CopyFiltersToManuscript /> */}
//     </div>
//   );
// }
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import css from "./adm.module.css";

import AddRuk from "../addRuk/addRuk";
import ProductList from "./productList";
import ManList from "./manList";
import OrderList from "./orderList";
import AddBlog from "../admBlog/addBlog";
import Carton from "./carton";
import CartonCha from "./cartonCha";
import SurveyForm from "./surveyForm";
import AddBooksTest from "./addBooksTest";
import UserList from "./userList";
import SeoBlock from "./seoBlock";
import AutorAdm from "../autorAdm/autorAdm";
import HeroAdm from "../heroAdm/heroAdm";
import AddVideoOglyd from "./addVideoOglyd";
import UseFiles from "./useFiles";
import HeroListEditor from "./HeroListEditor";
import AutorListEditor from "./AutorListEditor";
import VotingResults from "./votingResults";
import PageListFor from "./pageListFor";
import ManageResponses from "./manageResponses";
import AdminManagement from "./adminManagement";
import ExportProducts from "./downloadButton";
import VideoReviews from "./VideoReviews";
import SurveyList from "./SurveyList";
import ManuscriptListEditor from "./ManuscriptList";
import BlogListEditor from "./BlogListEditor";
import CartonChaResults from "./CartonChaResults";
import PromoList from "./promoList";
import ActionList from "./ActionList";
import CartDiscountManager from "./CartDiscountManager";
import AddProductBundle from "./AddProductBundle";
import AllPop from "./allPop";
import SaleList from "./SaleList";
import BusinessChatsPage from "./BusinessChatsPage";
import DownloadRozetkaXmlButton from "./xml";
import SeriesAdmin from "./SeriesAdmin";
const SECTION_COMPONENTS = {
  admins: AdminManagement,
  pages: PageListFor,
  addBooks: AddBooksTest,
  series: SeriesAdmin,
  bundle: AddProductBundle,
  addMan: AddRuk,
  editRukopus: ManuscriptListEditor,
  bookList: ProductList,
  manList: ManList,
  manuscriptResp: ManageResponses,
  addBlog: AddBlog,
  blogList: BlogListEditor,
  videoAdd: AddVideoOglyd,
  videoList: VideoReviews,
  promo: PromoList,
  discount: ActionList,
  sale: SaleList,
  discForSum: CartDiscountManager,
  cartonCha: CartonCha,
  coverVoting: CartonChaResults,
  votingResults: VotingResults,
  question: SurveyForm,
  surveyList: SurveyList,
  user: UserList,
  seo: SeoBlock,
  author: AutorAdm,
  authorList: AutorListEditor,
  hero: HeroAdm,
  heroList: HeroListEditor,
  photoChange: UseFiles,
  popup: AllPop,
  businessChat: BusinessChatsPage,
};

const MENU_ITEMS = [
  { key: "admins", label: "Адміни", adminOnly: true },
  { key: "pages", label: "Сторінки сайту" },
  { key: "addBooks", label: "Додати книгу" },
  { key: "series", label: "Серії книг" },
  { key: "bundle", label: "Каталог Cross-sell" },
  { key: "addMan", label: "Додати рукопис" },
  { key: "editRukopus", label: "Список Рукописів" },
  { key: "bookList", label: "Список товарів" },
  { key: "manList", label: "Список рукописів" },
  { key: "manuscriptResp", label: "Відгуки в рукописах" },
  { key: "orders", label: "Список замовлень", isRoute: true },
  { key: "addBlog", label: "Додати статтю" },
  { key: "blogList", label: "Список статей" },
  { key: "videoAdd", label: "Додати відеоогляд" },
  { key: "videoList", label: "Відеоогляди" },
  { key: "promo", label: "Промокод" },
  { key: "discount", label: "Акції" },
  { key: "sale", label: "Розпродаж" },
  { key: "discForSum", label: "Знижка від суми" },
  { key: "cartonCha", label: "Редагувати обкладинку" },
  { key: "coverVoting", label: "Голосування за обкладинку" },
  { key: "votingResults", label: "Результати голосування" },
  { key: "question", label: "Додати опитування" },
  { key: "surveyList", label: "Список опитувань" },
  { key: "user", label: "Список користувачів" },
  { key: "seo", label: "Seo" },
  { key: "author", label: "Додати автора" },
  { key: "authorList", label: "Список авторів" },
  { key: "hero", label: "Додати героя" },
  { key: "heroList", label: "Список Героїв" },
  { key: "photoChange", label: "Змінити файли книги" },
  { key: "popup", label: "Pop-Up" },
  { key: "businessChat", label: "Бізнес чати" },
];

export default function FullAdm({ admCha }) {
  const [activeSection, setActiveSection] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  const isOrdersRoute = location.pathname.startsWith("/adm/order");

  const ActiveComponent = useMemo(() => {
    if (!activeSection) return null;
    return SECTION_COMPONENTS[activeSection] || null;
  }, [activeSection]);

  useEffect(() => {
    const sectionToOpen = location.state?.openSection;
    if (!sectionToOpen) return;

    setActiveSection(sectionToOpen);

    navigate(location.pathname, {
      replace: true,
      state: null,
    });
  }, [location.state, location.pathname, navigate]);

  const openOrdersPage = () => {
    setActiveSection(null);
    navigate("/adm/order/1");
  };

  const openLocalSection = (sectionKey) => {
    if (isOrdersRoute) {
      navigate("/adm", {
        state: { openSection: sectionKey },
      });
      return;
    }

    setActiveSection((prev) => (prev === sectionKey ? null : sectionKey));
  };

  const isItemActive = (key) => {
    if (key === "orders") return isOrdersRoute && !activeSection;
    return activeSection === key;
  };

  return (
    <div className={css.fullAdmWrapp}>
      <div className={css.admList}>
        <ul className={css.listUlForAdm}>
          {MENU_ITEMS.map((item) => {
            if (item.adminOnly && !admCha) return null;

            return (
              <li key={item.key} className={css.listUlForAdmLi}>
                <button
                  type="button"
                  onClick={() =>
                    item.isRoute ? openOrdersPage() : openLocalSection(item.key)
                  }
                  className={`${css.listUlForAdmLiA} ${
                    isItemActive(item.key) ? css.listUlForAdmLiAA : ""
                  }`}
                >
                  {item.label}
                </button>
              </li>
            );
          })}

          <ExportProducts />
          <DownloadRozetkaXmlButton />
        </ul>
      </div>

      {isOrdersRoute && !activeSection && <OrderList />}
      {!isOrdersRoute && ActiveComponent ? <ActiveComponent /> : null}
    </div>
  );
}
